import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import { useEffect, useState } from "react";
import { StatusFlagModel } from "app/services/api/types/statusFlags/models/StatusFlagModel";
import AddStatusFlagForm from "../templates/AddStatusFlagForm";

export interface Props {
  isVisible: boolean;
  onClose: () => void;
  onSuccess: () => void;
  flag?: StatusFlagModel;
}

export function CreateEditFlagModal({
  isVisible,
  onClose,
  onSuccess,
  flag,
}: Props) {
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsEditing(!!flag);
    }
  }, [isVisible, flag]);

  return (
    <ReusableModal
      isVisible={isVisible}
      onClose={onClose}
      title={isEditing ? "Edit Status Flag" : "Create New Status Flag"}
      className="w-full max-w-[737px] mx-auto "
      hasCancelButton
      isEditing={isEditing}
    >
      <AddStatusFlagForm
        onClose={onClose}
        onSuccess={onSuccess}
        isEditing={isEditing}
        flag={flag}
      />
    </ReusableModal>
  );
}
